import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { sizeCategoryIndexInfiniteOptions } from '$api-client/@tanstack/react-query.gen'

export function useInfiniteSizeCategoryOptions() {
  const [search, setSearch] = useState<string>('')
  const [page, setPage] = useState<number>(1)

  const { fetchNextPage, data, hasNextPage, isLoading, isFetchingNextPage } = useInfiniteQuery({
    ...sizeCategoryIndexInfiniteOptions({
      query: {
        query: search,
      },
    }),
    getNextPageParam: (lastPage) => lastPage.meta.current_page !== lastPage.meta.last_page ? lastPage.meta.current_page + 1 : undefined,
    initialPageParam: page,
  })

  const onSearch = (value: string) => {
    setSearch(value)
    setPage(1)
  }

  const options = data?.pages.flatMap(p => p.data.map(c => ({ id: String(c.id), value: c.values?.name ?? '-' }))) ?? []

  return {
    options,
    async: {
      fetchNextPage,
      hasNextPage,
      isLoading: isLoading || isFetchingNextPage,
      isFetchingNextPage,
    },
    search: {
      onSearchChange: onSearch,
      search,
    },
  }
}
